var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDowload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.085 12L17.2122 8.87281C17.5959 8.48906 17.5959 7.86687 17.2122 7.48281L16.5172 6.78781C16.1334 6.40406 15.5113 6.40406 15.1272 6.78781L12 9.915L8.87281 6.78781C8.48906 6.40406 7.86688 6.40406 7.48281 6.78781L6.78781 7.48281C6.40406 7.86656 6.40406 8.48875 6.78781 8.87281L9.915 12L6.78781 15.1272C6.40406 15.5109 6.40406 16.1331 6.78781 16.5172L7.48281 17.2122C7.86656 17.5959 8.48906 17.5959 8.87281 17.2122L12 14.085L15.1272 17.2122C15.5109 17.5959 16.1334 17.5959 16.5172 17.2122L17.2122 16.5172C17.5959 16.1334 17.5959 15.5113 17.2122 15.1272L14.085 12Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDowload);
export default __webpack_public_path__ + "static/media/dowload.b16b9eb1d69591738a905c3b4d7913de.svg";
export { ForwardRef as ReactComponent };